import axios from "axios";
import ENDPOINT from "../data/ENDPOINT";
import SecurityHeaders from "../data/SecurityHeaders";

// Issued certificates for the logged-in user (optionally for one course).
const GetUserCertificates = async ({ payload }) => {
  const formData = new FormData();
  if (payload.session) formData.append("session", payload.session);
  if (payload.user_id) formData.append("user_id", payload.user_id);
  if (payload.course_url) formData.append("course_url", payload.course_url);

  const res = await axios.post(ENDPOINT + "user-issued-certificates.php", formData, SecurityHeaders);
  return res ? res.data : null;
};

export default GetUserCertificates;
